/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IsUserIdPortenValidatedResponse
 */
export interface IsUserIdPortenValidatedResponse {
    /**
     * 
     * @type {boolean}
     * @memberof IsUserIdPortenValidatedResponse
     */
    isValidated?: boolean;
}

/**
 * Check if a given object implements the IsUserIdPortenValidatedResponse interface.
 */
export function instanceOfIsUserIdPortenValidatedResponse(value: object): value is IsUserIdPortenValidatedResponse {
    return true;
}

export function IsUserIdPortenValidatedResponseFromJSON(json: any): IsUserIdPortenValidatedResponse {
    return IsUserIdPortenValidatedResponseFromJSONTyped(json, false);
}

export function IsUserIdPortenValidatedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IsUserIdPortenValidatedResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isValidated': json['isValidated'] == null ? undefined : json['isValidated'],
    };
}

export function IsUserIdPortenValidatedResponseToJSON(json: any): IsUserIdPortenValidatedResponse {
    return IsUserIdPortenValidatedResponseToJSONTyped(json, false);
}

export function IsUserIdPortenValidatedResponseToJSONTyped(value?: IsUserIdPortenValidatedResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isValidated': value['isValidated'],
    };
}

